import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { SiteFooter } from './components/SiteFooter';
import { SiteHeader } from './components/SiteHeader';
import { LandingPage } from './pages/LandingPage';
import { LegalPage, legalDocumentTitle, type LegalKind } from './pages/LegalPage';
import './styles.css';

function DocumentTitle({ title }: { title: string }) {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return null;
}

function LegalRoute({ kind }: { kind: LegalKind }) {
  return (
    <>
      <DocumentTitle title={legalDocumentTitle(kind)} />
      <SiteHeader
        links={[
          { to: '/privacy', label: 'Privacy' },
          { to: '/terms', label: 'Terms' },
          { to: '/support', label: 'Support' },
        ]}
        ctaHref="/"
        ctaLabel="Home"
      />
      <LegalPage kind={kind} />
      <SiteFooter />
    </>
  );
}

function HomeRoute() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <>
      <DocumentTitle title="Gifty — Never forget an occasion. Never repeat a gift." />
      <SiteHeader />
      <LandingPage />
      <SiteFooter />
    </>
  );
}

export default function App() {
  return (
    <>
      <div className="bg" aria-hidden />
      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/privacy" element={<LegalRoute kind="privacy" />} />
        <Route path="/terms" element={<LegalRoute kind="terms" />} />
        <Route path="/support" element={<LegalRoute kind="support" />} />
        <Route path="/help" element={<Navigate to="/support" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
